import angular from 'angular';
import template from './patient-modal-continue-without-video.html';
import PatientPhotoCaptureNotification from '../patient-photo-capture-notification/patient-photo-capture-notification';
const patientModalContinueWithoutVideo = {
    template,
    bindings: {
        patient: '<',
        room: '<',
        onCheckIn: '&',
        onEnableCamera: '&',
        onEnableWebcamAndCheckIn: '&',
        checkInPromise: '<',
        isEnableCameraButtonClicked: '<',
        currentInstitution: '<',
    },
};
export default angular
    .module('doxy.patient.modal.patientModalContinueWithoutVideo', [
    PatientPhotoCaptureNotification,
])
    .component('patientModalContinueWithoutVideo', patientModalContinueWithoutVideo).name;
